const ContentListing = (function ContentListing() {
    let component = document.querySelector('.content-listing');
    let openSidebarBtn = document.querySelector('.sidebar-open');
    let closeSidebarBtn = document.querySelector('.sidebar-close');
    let listingSidebar = document.querySelector('.listing-sidebar');
    let overlay = document.querySelector('.overlay');
    let body = document.querySelector('body');
    let filterOptionsElements = document.querySelectorAll('.filter-list .custom-checkbox-input');
    let filtersCount = 0;
    let activeFilters = [];
    let savedFilters = [];
    let focusableElements = listingSidebar && listingSidebar.querySelectorAll('a, button, input, textarea, select');
    let showListingResults = document.querySelector('.show-listing-results');
    let urlParams = new URL(location.href).searchParams;
    let clearAllFiltersBtn = document.querySelector('.clear-all-listing-filters');
    let listingSortSelect = document.querySelector('.listing-sort');
    let paginationBtns = document.querySelectorAll('.page-number');

    function attachEvents() {
        paginationBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
				e.preventDefault();
				if (e.currentTarget.disabled == true) {
					return;
				}
				e.currentTarget.disabled = true;
                switch (e.currentTarget.getAttribute("page-id")){
                    case "next" :
                        goToNextPage();
                        break;
                    case "previous" :
                        goToPreviousPage();
                        break;
                    default:
                        goToPage(e.target.getAttribute("page-id"));
                }
                
            })
        })
        openSidebarBtn && openSidebarBtn.addEventListener('click', function(e) {
            e.preventDefault();
            openSidebar();
        })
        closeSidebarBtn && closeSidebarBtn.addEventListener('click', function(e) {
            e.preventDefault();
            closeSidebar();
        })
        overlay && overlay.addEventListener('click', function(e) {
            closeSidebar();
        })
        filterOptionsElements.forEach(filter => {
            filter.addEventListener('click', function() {
                toggleActiveFilters(this);
            })
        })
        document.addEventListener('keydown', function(e) {
            trapSidebarFocus(e);
        })
        showListingResults && showListingResults.addEventListener('click', function() {
            setCategoryParams();
        })
        clearAllFiltersBtn && clearAllFiltersBtn.addEventListener('click', function(e) {
            e.preventDefault();
            clearFilters();
        })
        listingSortSelect && listingSortSelect.addEventListener('change', function(e) {
            setSortParams(this.options[this.selectedIndex].value);
        })
    }

    function openSidebar() {
        overlay.classList.add('show', 'no-blur');
        body.classList.add('overflow-hidden');
        listingSidebar.classList.add('show');
        listingSidebar.focus();
    }

    function closeSidebar() {
        overlay.classList.remove('show', 'no-blur');
        body.classList.remove('overflow-hidden');
        listingSidebar.classList.remove('show');
        restoreChecked();
        openSidebarBtn.focus();
    }

    function trapSidebarFocus(e) {
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) {
            if (document.activeElement === focusableElements[0]) {
                focusableElements[focusableElements.length - 1].focus();
                e.preventDefault();
            }
        } else {
            if (document.activeElement === focusableElements[focusableElements.length - 1]) {
                focusableElements[0].focus();
                e.preventDefault();
            }
        }
    }

    function clearFilters() {
        activeFilters = [];
        filterOptionsElements.forEach(filter => {
            filter.checked = false;
        })
        updateFiltersCount(0);
    }

    function checkActiveFilters() {
        if (urlParams.get('category')) {
            let foundFilters = urlParams.get('category').toLowerCase().split('_');
            savedFilters = foundFilters;
            activeFilters = savedFilters.map(el => el);

            filterOptionsElements.forEach(filter => {
                if (activeFilters.includes(filter.getAttribute('name').toLowerCase())) {
                    filter.checked = true;
                    filtersCount++;
                    updateFiltersCount(filtersCount);
                }
            })
        }
    }

    function restoreChecked() {
        filterOptionsElements.forEach(filter => {
            filter.checked = false;
            if (savedFilters.includes(filter.getAttribute('name').toLowerCase())) {
                filter.checked = true;
            }
        })

        updateFiltersCount(savedFilters.length);
        activeFilters = savedFilters.map(el => el);
    }

    function toggleActiveFilters(filter) {
        if (filter.checked) {
            activeFilters.push(filter.getAttribute('name').toLowerCase());
            filtersCount++;
            updateFiltersCount(filtersCount);
        } else {
            activeFilters.splice(activeFilters.indexOf(filter.getAttribute('name').toLowerCase()), 1);
            filtersCount--;
            updateFiltersCount(filtersCount);
        }
    }

    function setCategoryParams() {
        if(activeFilters.length > 0) {
            urlParams.set('category', activeFilters.join('_'));
        } else {
            urlParams.delete('category');
        }

        window.location.hash = '#listing-title-anchor';
        window.location.search = urlParams;
    }

    function updateFiltersCount(count) {
        filtersCount = count;

        document.querySelectorAll('.listing-filter-count').forEach(el => {
            el.innerHTML = '(' + count + ')';
        })
    }

    function goToPage(page){
        urlParams.set('pageNumber', page);
        window.location.hash = '#listing-title-anchor';
        window.location.search = urlParams;
    }

    function goToNextPage(){
        let currentPage = Number(urlParams.get("pageNumber"));
        let nextPage = currentPage === 0 ? 2 : currentPage + 1
        urlParams.set('pageNumber', nextPage);
        window.location.hash = '#listing-title-anchor';
        window.location.search = urlParams;
    }

	function goToPreviousPage(){
        var page = Number(urlParams.get("pageNumber")) - 1;
        urlParams.set('pageNumber', page);
        window.location.hash = '#listing-title-anchor';
		window.location.search = urlParams;
    }

    function setSortParams(value) {
        urlParams.set('sort', value);
        window.location.hash = '#listing-title-anchor';
        window.location.search = urlParams;
    }

    function updateSortDropdown() {
        if (urlParams.get('sort')) {
            listingSortSelect.value = urlParams.get('sort');
        }
    }

    function init() {
        if (!component) {
            return;
        }
        attachEvents();
        checkActiveFilters();
        updateSortDropdown();
    }
    
    // add a setTimeout 1000ms for the functions below in case the code is running on vite server
    init();
})();